import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslocoModule } from '@jsverse/transloco';

import { InlineSvgComponent } from '../../inline-svg/inline-svg.component';
import { UnderDevelopmentComponent } from '../../under-development/under-development.component';

export interface AnchorMenuItem {
  /** Scroll target, used only when the item has no `route`. */
  fragment?: string;
  route?: string;
  icon: string;
  text: string;
  disabled?: boolean;
  underDevelopment?: boolean;
}

@Component({
  selector: 'ui-anchor-menu',
  imports: [
    CommonModule, RouterModule, TranslocoModule, InlineSvgComponent, UnderDevelopmentComponent,
  ],
  templateUrl: './anchor-menu.component.html',
  styleUrl: './anchor-menu.component.scss',
  providers: [],
})
export class AnchorMenuComponent {
  /** Array of menu items with route, fragment, icon, and text properties. */
  menu = input<AnchorMenuItem[]>();
  /** Controls whether the component uses an anchor menu */
  anchorMenu = input<boolean>(true);
}
